// JavaScript Document

function botCheck() {
    var botPattern = '(googlebot/|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)',
        re = new RegExp(botPattern, 'i'),
        userAgent = navigator.userAgent;

    if (re.test(userAgent)) {
        return true;
    }
    else {
        return false;
    }
}

function load() {

    fetch(window.site_settings.admin_ajax+'?action=lazyload_comments&post_id='+window.site_settings.current_id).then(resp => resp.json()).then(obj => {
        const commentList = document.querySelector('.comment-list');
        if (typeof commentList !== 'undefined' && commentList !== null) {
            commentList.innerHTML = obj.html;
        }
    });
}

function lazyloadComments() {

    // Load comments if #comment found in url or if no scroll bar available.
    if (window.location.href.indexOf('#comment') > -1 || document.body.scrollHeight <= window.innerHeight) {
        load();
    }

    if (navigator.webdriver || botCheck()) {
        load();
    }
    else {
        const nativeContainer = document.querySelector('.comments-container');
        if (typeof nativeContainer !== 'undefined' && nativeContainer !== null) {
            let observer = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        const { isIntersecting } = entry;
                        if (isIntersecting) {
                            load();
                            observer = observer.disconnect();
                        }
                    }, {
                        root: nativeContainer, rootMargin: '500px 0px 0px 0px' });
                }
            );
            observer.observe(nativeContainer);
        }
    }
}

export default function init() {
    lazyloadComments();
}
